import * as React from '../../../../_snowpack/pkg/react.js';
import { AnimatePresence } from '../../../../_snowpack/pkg/framer-motion.js';
import { SliderWrapper, SliderCard } from './styles.js';
import { cards } from './cards.js';
import Dots from './dots.js';
const variants = {
  enter: direction => {
    return {
      x: direction > 0 ? 50 : -50,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: direction => {
    return {
      zIndex: 0,
      x: direction < 0 ? 50 : -50,
      opacity: 0
    };
  }
};
export const Carousel = ({
  page,
  direction,
  paginate,
  progress,
  setPage
}) => {
  return /*#__PURE__*/React.createElement(SliderWrapper, null, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false,
    custom: direction
  }, /*#__PURE__*/React.createElement(SliderCard, {
    key: page,
    custom: direction,
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit",
    transition: {
      x: {
        type: 'spring',
        stiffness: 300,
        damping: 200
      },
      opacity: {
        duration: 0.2
      }
    },
    drag: "x",
    dragConstraints: {
      left: 0,
      right: 0
    },
    dragElastic: 1,
    onDragEnd: (e, {
      offset,
      velocity
    }) => {
      const swipe = swipePower(offset.x, velocity.x);

      if (swipe < -swipeConfidenceThreshold) {
        paginate(1);
      } else if (swipe > swipeConfidenceThreshold) {
        paginate(-1);
      }
    }
  }, cards[page])), /*#__PURE__*/React.createElement(Dots, {
    paginate: paginate,
    progress: progress,
    page: page,
    setPage: setPage
  }));
};
const swipeConfidenceThreshold = 10000;

const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};

export default Carousel;